// packages block
import React from "react";
import { TableRow, Checkbox, TableCell, makeStyles } from "@material-ui/core";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import moment from "moment";
import { dateFormat } from "../../../util/Date";
import CustomCheckbox from "../../customCheckbox";

const useStyles = makeStyles({
  customTable: {
    "& .MuiTableCell-alignLeft": {
      padding: "22px 0px 22px 0px",
    },
  },
});

export const BalanceRow = ({
  isItemSelected,
  selectionKey,
  handleClick,
  row,
  columns,
  openActionMenu,
  actionButtonClass,
  labelId,
}) => {
  const classes = useStyles();
  const AmountFormat = (e) => {
    const format = new Intl.NumberFormat("en-US").format(e);
    if (format.indexOf(".") > 0) {
      return format.substr(0, format.indexOf("."));
    } else {
      return new Intl.NumberFormat("en-US").format(e);
    }
  };

  return (
    <TableRow
      hover
      style={{
        borderBottom: "1px solid #636365",
        backgroundColor: isItemSelected ? "#FAF9F6" : "white",
      }}
      role="checkbox"
      aria-checked={isItemSelected}
      tabIndex={-1}
      key={row.name}
      selected={isItemSelected}
      classes={{ root: classes.customTable }}
    >
      <TableCell padding="checkbox">
        <CustomCheckbox
          onClick={(event) => handleClick(event, row[selectionKey])}
          checked={isItemSelected}
          inputProps={{ "aria-labelledby": labelId }}
        />
      </TableCell>

      <TableCell align="left" style={{ fontWeight: 500, padding: 10 }}>
        {row["payeeType"] === "STUDENT"
          ? row["studentRegNo"]
          : row["parentRegNo"]}
      </TableCell>
      <TableCell
        align="left"
        style={{ textTransform: "capitalize", fontWeight: 500, padding: 10 }}
      >
        {`${row["firstName"]} ${row["lastName"]}`}
      </TableCell>
      <TableCell align="left" style={{ fontWeight: 500, padding: 10 }}>
        {row["total_balance_amount"] === "-"
          ? row["total_balance_amount"]
          : AmountFormat(row["total_balance_amount"])}
      </TableCell>
      <TableCell align="left" style={{ fontWeight: 500, padding: 10 }}>
        {row["total_balance_amount"] === "-" ? "-": row["dueDate"] ? dateFormat(row["dueDate"]) : null}
      </TableCell>
      <TableCell align="left">
        <div
          role="presentation"
          onClick={(e) => {
            if (row["total_balance_amount"] !== "-") openActionMenu(e, row);
          }}
          className={actionButtonClass}
        >
          <MoreHorizIcon
            color={row["total_balance_amount"] === "-" ? "disabled" : "action"}
          />
        </div>
      </TableCell>
    </TableRow>
  );
};
